<template>
  <b-form-group>
    <label :for="field" v-if="$slots.label || label">
      <slot v-if="$slots.label" name="label" />
      <span v-else-if="label">
        {{ label }}
      </span>
      <span
        v-if="required($validator._base.fields.items.find((_i) => _i.name === field))"
        class='text-danger font-bold'
      >
        *
      </span>
    </label>
    <div>
      <slot :invalid="$validator._base.errors.has(this.field) ? false : null" />
    </div>
    <v-invalid-feedback v-if="$validator._base.errors.has(this.field)">
      {{ this.$validator._base.errors.first(this.field) }}
    </v-invalid-feedback>
  </b-form-group>
</template>
<script>
import VInvalidFeedback from '@/febos/global/customDocuments/components/VInvalidFeedback';

export default {
  name: 'validate-field',
  components: {
    VInvalidFeedback,
  },
  props: {
    field: {
      type: String,
      required: true,
    },
    label: String,
  },
  methods: {
    required(item) {
      return !(!item || !item.rules || !Object.keys(item.rules).length || !Object.keys(item.rules).includes('required'));
    },
  },
};
</script>
